import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer-content">
                <p>&copy; 2024 BioSite. Tüm hakları saklıdır.</p>
      </div>
    </footer>
  );
};

export default Footer;